// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        paginationType: bcSfFilterConfig.custom.enable_infinite_scrolling ? 'infinite' : 'default',
    }
};

var bcSfFilterTemplate = {
    'saleLabelHtml': '<div class="sale-item icn">' + bcSfFilterConfig.label.sale + '</div>',
    'soldOutLabelHtml': '<div class="so icn">' + bcSfFilterConfig.label.sold_out + '</div>',
    'newLabelHtml': '<div class="new icn">' + bcSfFilterConfig.label.new + '</div>',
    'vendorHtml': '<div class="product-grid--vendor-text">{{itemVendorLabel}}</div>',
    
    // Grid Template
    'productGridItemHtml':  '<div class="grid__item '+ bcSfFilterConfig.custom.grid_item_width +'">' +
                                '<div class="grid-view-item">' +
                                    '<div class="grid-view-item-image">' +
                                        '{{itemImages}}' +
                                        '{{itemQuickview}}' +
                                    '</div>' +
                                    '<div class="grid-view-item--desc-wrapper grid-uniform">' +
                                        '<div class="grid__item large--one-whole">' +
                                            '{{itemVendor}}' +
                                            '<p class="product-grid--title">' +
                                                '<a href="{{itemUrl}}">{{itemTitle}}</a>' +
                                            '</p>' +
                                            '<p class="product-grid--price">{{itemPrice}}</p>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml' : '<li class="pagination-arrow"><a href="{{itemUrl}}"><i class="fa fa-chevron-left"></i></a></li>',
    'previousDisabledHtml': '<li class="prev disabled"><a href="#" onclick="return false;">&laquo;</a></li>',
    'nextActiveHtml': '<li class="pagination-arrow"><a href="{{itemUrl}}"><i class="fa fa-chevron-right"></i></a></li>',
    'nextDisableHtml': '<li class="next disabled"><a href="#" onclick="return false;">&raquo;</a></li>',
    'pageItemHtml': '<li class="pagination-number"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active pagination-number"><a href="" title="">{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="ellipsis">{{itemTitle}}</li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>'
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
     /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/
  
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendor ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = '';
    if (onSale) {
        if (priceVaries) {
            itemPriceHtml += bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, '<span class="money">' + this.formatMoney(data.price_min) + '</span>');
        } else {
            itemPriceHtml += '<span class="product-grid--compare-price">' + this.formatMoney(data.compare_at_price_min) + '</span>';
            itemPriceHtml += ' <span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
    } else {
        if (priceVaries) {
            itemPriceHtml += ' <span class="product-grid--from-wrapper">' + bcSfFilterConfig.label.from_price + '</span> <span class="money">' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
    }
    if (soldOut) {
        itemPriceHtml += '<br><strong>' + bcSfFilterConfig.label.sold_out + '</strong>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Images
    var itemImagesHtml = '';
    if (bcSfFilterConfig.custom.hover_effect) {
        if (images.length > 1) {
            itemImagesHtml += '<div class="reveal">';
            itemImagesHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
            itemImagesHtml += '<img src="' + this.optimizeImage(images[0]['src'], '760x') + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
            itemImagesHtml += '<div class="hidden">';
            itemImagesHtml += '<img src="' + this.optimizeImage(images[1]['src'], '760x') + '" alt="{{itemTitle}}" class="img-responsive" />';
            itemImagesHtml += '</div>';
            itemImagesHtml += '</a>';
            itemImagesHtml += '</div>';
        } else {
            itemImagesHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
            itemImagesHtml += '<img src="' + this.getFeaturedImage(images, '760x') + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
            itemImagesHtml += '</a>';
        }
    } else {
        itemImagesHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
        itemImagesHtml += '<img src="' + this.getFeaturedImage(images, '760x') + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
        itemImagesHtml += '</a>';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Quick view
    var itemQuickviewHtml = '';
    if (bcSfFilterConfig.custom.quick_shop_enable) {
        itemQuickviewHtml += '<div class="shop-now-wrapper">';
        itemQuickviewHtml += '<a class="shop-now-button" href="{{itemUrl}}">' + bcSfFilterConfig.label.quick_shop + '</a>';
        itemQuickviewHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickview}}/g, itemQuickviewHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisableHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        paginationHtml = jQ.parseHTML(paginationHtml);
        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            html = jQ.parseHTML(html);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    //Call theme function
  	if (window.wetheme && typeof wetheme.load_all == 'function'){
        wetheme.load_all({});
    }
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) { var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};

BCSfFilter.prototype.slugify = function(text) {
    // return text.toString().toLowerCase()
    //     .replace(/[\s\/]+/g, '-')    // Replace spaces with -
    //     .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
    //     .replace(/\-\-+/g, '-')     // Replace multiple - with single -
    //     .replace(/^-+/, '')         // Trim - from start of text
    //     .replace(/-+$/, '')         // Trim - from end of text
    text = text.toLowerCase();

    // Remove Latin
    var from = "àáäâãåèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;";
    var to   = "aaaaaaeeeeeiiiiiooooouuuuunc------";
    for (var i = 0, l = from.length ; i<l ; i++)
        text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));

    return text.replace(/[\s\/]+/g, '-')    // Replace spaces with -
        .replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -
        .replace(/\-\-+/g, '-')     // Replace multiple - with single -
        .replace(/^-+/, '')         // Trim - from start of text
        .replace(/-+$/, '')         // Trim - from end of text
};

BCSfFilter.prototype.buildFilterOptionSwatchData = function(fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) {
    if (this.checkShowFilterOptionItem(fOItemValue, fOData)) {
        var iLabel = fOItemValue.key, iValue = fOItemValue.key;
        var swatchName = iValue;
        if (fOType == 'collection') {
            iLabel = fOItemValue.label, iValue = fOItemValue.handle;
            swatchName = iLabel;
        }

        var colorOptionsArr = this.getSettingValue('general.colorOptionsArr');
        // Get prefix of swatch from filter option id
        // Ex: By option: pf_opt_color -> color, pf_opt_size -> size
        //     By tag: pf_t_color -> color, pf_t_dimension -> dimension
        var prefixSwatch = fOId.replace('pf_t_', '').replace('pf_opt_', '');
        // Deprecated
        if (colorOptionsArr != '') {
            var isColor = colorOptionsArr.filter(function(item) {
                return fOId.indexOf(item) > -1;
            });
            if (typeof isColor[0] !== 'undefined') {
                prefixSwatch = 'color';
            }
        }
        // Get Swatch name
      	console.log(swatchName);
        swatchName = this.customizeSwatchFileName(swatchName, fOItemValue, fOData);
      console.log(swatchName);
        // Get item HTML Template & Build data
        var html = this.getTemplate('filterOptionSwatchItem');
        html = this.buildFilterOptionItem(html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData);
        // Add Image
        var filePath = getFilePath(prefixSwatch + '-' + swatchName, this.swatchExtension, this.getSettingValue('general.swatchImageVersion'));
        html = html.replace(/{{itemImageValue}}/g, filePath);
        // Add border
        var border = fOData.hasOwnProperty('borderSwatch') && fOData.borderSwatch != '' ? fOData.borderSwatch : 'none';
        html = html.replace(/{{itemBorder}}/g, border);
        return html;
    }
    return '';
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
